import Http from '../utils/http'
import store from 'store/index'

export const getAllPaged = (page = 1, extraParams = {}) => Http.get('/emails', { params: { page, ...extraParams } })

export const getHandler = (email) => Http.get(`/emails/${email}/handler`)

export const attachDeal = (email, deal) => Http.put(`/emails/${email}/deal/${deal}`)

export const getAll = (deal, params = {}) => {
    return Http.get(`/deals/${deal}/emails`, { params })
       .then(response => {
           store.dispatch('setEmails', response.data)
       })
}

export const create = (deal, payload) => {
    return Http.post(`/deals/${deal}/emails`, payload)
       .then(response => {
           store.dispatch('saveEmail', response.data)
           return response.data
       })
}

export const update = (deal, id, payload) => {
    return Http.put(`/deals/${deal}/emails/${id}`, payload)
       .then(response => {
           store.dispatch('saveEmail', response.data)
           return response.data
       })
}

export const destroy = (deal, id) => {
    return Http.delete(`/deals/${deal}/emails/${id}`)
       .then(() => {
           store.dispatch('destroyEmail', id)
       })
}

export const createMassive = (payload) => Http.post(`/emails/massive`, payload)

export const signature = (deal) => Http.get(`/deals/${deal}/emails/signature/replace`)

export const replace = (template, deal) => Http.get(`/deals/${deal}/emails/${template}/replace`)

export const get = (deal, email) => Http.get(`/deals/${deal}/emails/${email}`)

export const getByCode = (code) => Http.get(`/emails/${code}`)



// WEBPACK FOOTER //
// ./src/services/emails.js